import React from "react"
import { Grid, Link } from "@mui/material";
import DesktopMenu from "./desktopMenudt.js"
import MobileMenu from "./mobileMenudt.js"

// import './menu.css'

import logod from '../../../images/new-logo.png'
import logo from '../../../images/new-logo.png'

const MenuList = [
    [
        'Dashboard', // title
        '/dashboard', // Link
        'Global---menu-link hover px-3 py-2 mb-3', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'dashboard'
    ],
    [
        'Rewards',
        '/rewards', 
        'Global---menu-link hover px-3 py-2 mb-3', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'savings'
    ],
    [
        'NFTS',
        '/nfts', 
        'Global---menu-link hover px-3 py-2 mb-3', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'store'
    ],
    [
        'Chart',
        'https://www.dextools.io/app/bsc/pair-explorer/0x305dd2595f8877c0ffaf762999e1b1153355fbba',
        'Global---menu-link hover px-3 py-2 mb-3', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'candlestick_chart'
    ],
    [
        'Buy Now',
        'https://pancakeswap.finance/swap?outputCurrency=0xBa8d9B8F138EE5269A5C23339775510D050b75C1',
        'Global---menu-link hover px-3 py-2 mb-3', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'account_balance_wallet'
    ],
    [
        'Play Now',
        'https://game.metasnooker.io/',
        'MS---Neon--Button btn text-center hover px-3 py-2 mb-3', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        ''
    ]
];

const handleLogout = () => {
    // console.log('User has been logd: ', localStorage.getItem("token") )
    localStorage.clear();
    // console.log('User has been logd: ', localStorage.getItem("token") )
    window.location.replace("/login");
}
const Menu = () => {
    return(
        <Grid item xs={12} md={2} className="Global-main-menu-outer text-md-center w-100 pb-0 py-md-4 px-0 ">
            <div className="d-none d-md-block">
                <DesktopMenu 
                    siteLogo={logod}
                    menuList={MenuList}
                    logout= {handleLogout}
                />
            </div>
            <div className="d-md-none">
                <MobileMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                    logout= {handleLogout}
                />
            </div>
        </Grid>
    )
}

export default Menu;